import api from './api'

export const getLikeProfessionals = pageNumber => api.get(`/like/professionals/?page=${pageNumber}`)

export const postLikeProfessionalsIds = professionalsIds =>
  api.post('/like/professionals/', professionalsIds)

export const postLikeProfessionalId = professionalId =>
  api.post('/like/professional/', professionalId)
